/* JerseyFC — add-to-cart micro-confirmation.
   Honest nudge: a brief "✓ Added to cart" toast + a pulse on the cart count, so
   the success is unmistakable and the eye goes to the cart. Fires only on a
   genuine cart-count increase that followed an add-to-cart click. */
(function () {
  'use strict';

  var css = document.createElement('style');
  css.textContent = [
    '@keyframes jfc-cart-pulse{0%,100%{transform:scale(1)}35%{transform:scale(1.5)}}',
    '.cart-count-bubble.jfc-cart-pulse{animation:jfc-cart-pulse .55s cubic-bezier(.34,1.56,.64,1);}',
    '#jfc-atc-toast{position:fixed;top:78px;left:50%;transform:translateX(-50%) translateY(-12px);z-index:10001;display:flex;align-items:center;gap:10px;background:rgba(18,18,26,.94);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);border:1px solid rgba(47,210,122,.4);color:#F2EFE8;font-family:Archivo,ui-sans-serif,system-ui,sans-serif;font-size:13.5px;font-weight:600;padding:11px 18px;border-radius:12px;box-shadow:0 18px 50px -18px rgba(0,0,0,.7);opacity:0;pointer-events:none;transition:opacity .3s ease,transform .3s cubic-bezier(.34,1.56,.64,1);}',
    '#jfc-atc-toast.show{opacity:1;transform:translateX(-50%) translateY(0);}',
    '.jfc-att-tick{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#2FD27A;color:#0B0B0F;font-weight:900;font-size:12px;flex-shrink:0;}',
    '@media(max-width:749px){#jfc-atc-toast{top:auto;bottom:88px;}}'
  ].join('');
  document.head.appendChild(css);

  function bubble() { return document.querySelector('.cart-count-bubble'); }
  function readCount() { var b = bubble(); return b ? (b.textContent || '').replace(/\D/g, '') : null; }

  function pulse() {
    var b = bubble(); if (!b) return;
    b.classList.remove('jfc-cart-pulse'); void b.offsetWidth; b.classList.add('jfc-cart-pulse');
  }
  function toast() {
    var t = document.getElementById('jfc-atc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'jfc-atc-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span class="jfc-att-tick" aria-hidden="true">✓</span><span>Added to cart</span>';
      document.body.appendChild(t);
    }
    t.classList.remove('show'); void t.offsetWidth; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2000);
  }

  /* Only confirm when the increase followed an actual add-to-cart click. */
  var armed = false, armTimer;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.product-form__submit, .jfc-sk-btn, button[name="add"]');
    if (b) { armed = true; clearTimeout(armTimer); armTimer = setTimeout(function () { armed = false; }, 4000); }
  }, true);

  /* The Dawn cart drawer (or notification) IS the primary confirmation — it
     slides in and shows the item. So only toast when nothing opens (e.g. the
     Avada "Buy it with" bundle adds silently), never double up on the drawer. */
  function drawerOpen() {
    var d = document.querySelector('cart-drawer, #CartDrawer');
    if (d && d.classList.contains('active')) return true;
    var n = document.querySelector('cart-notification, #cart-notification');
    if (n && n.classList.contains('active')) return true;
    return false;
  }

  var last = readCount();
  function check() {
    var now = readCount();
    if (now === null || now === last) return;
    var grew = last === null || parseInt(now, 10) > parseInt(last, 10);
    last = now;
    if (grew) {
      pulse();
      if (armed) {
        armed = false;
        setTimeout(function () { if (!drawerOpen()) toast(); }, 380);
      }
    }
  }

  function start() {
    last = readCount();
    var target = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icons') || document.body;
    new MutationObserver(check).observe(target, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
